import {
	assetPermissionChecker,
	PermissionName,
	PermissionMatrixName,
} from '@netx/core-permissions-next';
import type {IAsset} from '../schema';

export const canDeleteAsset = (
	asset?: Pick<IAsset, 'permissionMatrix' | 'permissions'>,
): boolean => {
	if (asset == null) return false;
	return assetPermissionChecker({
		asset,
		permissionMatrixName: PermissionMatrixName.DELETE,
		permissionName: PermissionName.DELETE,
	});
};
